var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedStarryBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 927,
    height: 473,
    viewBox: "0 0 927 473",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_348_209)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 928,
    height: 473,
    fill: "#F2604A"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_348_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M843.582 241.73L849.34 261.114L868.661 267.086L852.006 278.555L852.296 298.774L836.244 286.476L817.102 293.002L823.837 273.935L811.717 257.748L831.934 258.259L843.582 241.73Z",
    fill: "white",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_348_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M632.22 439.582L612.837 445.34L606.864 464.661L595.395 448.006L575.176 448.296L587.474 432.244L580.948 413.102L600.015 419.837L616.202 407.717L615.691 427.934L632.22 439.582Z",
    fill: "white",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_348_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.623273 371.894L24.6962 388.67L52.7098 376.924L44.5811 406.19L64.4077 429.2L34.062 430.51L18.3054 456.481L7.68179 428.025L-21.8845 421.064L1.89523 402.163L-0.623273 371.894Z",
    fill: "white",
    fillOpacity: 0.15
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_348_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M746.572 349.318L792.474 379.731L843.259 358.435L828.523 411.493L864.466 453.207L809.453 455.581L780.888 502.664L761.629 451.077L708.028 438.457L751.138 404.191L746.572 349.318Z",
    fill: "white",
    fillOpacity: 0.15
  })), /*#__PURE__*/React.createElement("path", {
    d: "M826.009 -23.9564L828.621 6.30395L855.242 20.9338L827.269 32.7716L821.583 62.6081L801.684 39.6606L771.547 43.4755L787.222 17.4583L774.283 -10.0231L803.874 -3.15853L826.009 -23.9564Z",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.918 55.2789L621.879 85.244L649.559 97.7561L622.593 111.736L619.247 141.925L597.621 120.597L567.873 126.747L581.474 99.5885L566.435 73.1983L596.47 77.7375L616.918 55.2789Z",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_348_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.2035 51.5334L90.2759 74.1325L110.225 84.9569L89.3722 93.9137L85.243 116.229L70.2829 99.1634L47.781 102.134L59.3884 82.6324L49.6113 62.1511L71.7482 67.1615L88.2035 51.5334Z",
    fill: "white",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.997 412.403L186.07 435.002L206.019 445.826L185.166 454.783L181.037 477.099L166.077 460.033L143.575 463.004L155.182 443.502L145.405 423.021L167.542 428.031L183.997 412.403Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.997 71.4029L920.07 94.002L940.019 104.826L919.166 113.783L915.037 136.099L900.077 119.033L877.575 122.004L889.182 102.502L879.405 82.0206L901.542 87.0311L917.997 71.4029Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.997 -28.5971L282.07 -5.99797L302.019 4.82641L281.166 13.7832L277.037 36.0989L262.077 19.0329L239.575 22.004L251.182 2.50195L241.405 -17.9794L263.542 -12.9689L279.997 -28.5971Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_348_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M898.672 246.238L899.84 257.965L910.243 263.504L899.451 268.24L897.398 279.844L889.56 271.043L877.888 272.678L883.836 262.504L878.676 251.908L890.191 254.42L898.672 246.238Z",
    fill: "#FAFDFF",
    fillOpacity: 0.15
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_348_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.712 470.672L447.985 471.84L442.446 482.243L437.71 471.451L426.106 469.397L434.907 461.56L433.272 449.888L443.446 455.836L454.042 450.675L451.53 462.191L459.712 470.672Z",
    fill: "#FAFDFF",
    fillOpacity: 0.15
  })), /*#__PURE__*/React.createElement("path", {
    d: "M261.812 416.798L262.98 428.524L273.383 434.064L262.591 438.8L260.538 450.404L252.7 441.603L241.028 443.237L246.976 433.064L241.816 422.468L253.331 424.98L261.812 416.798Z",
    fill: "#FAFDFF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.812 14.7979L471.98 26.5243L482.383 32.0639L471.591 36.7996L469.538 48.404L461.7 39.6031L450.028 41.2374L455.976 31.0636L450.816 20.4681L462.331 22.9799L470.812 14.7979Z",
    fill: "#FAFDFF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8119 -6.20213L83.9799 5.52429L94.3829 11.0639L83.5911 15.7996L81.5377 27.404L73.7001 18.6031L62.0278 20.2374L67.9758 10.0636L62.8157 -0.531885L74.3309 1.97986L82.8119 -6.20213Z",
    fill: "#FAFDFF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_348_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M879.074 28.4414L879.864 36.369L886.897 40.114L879.601 43.3155L878.213 51.1606L872.914 45.2108L865.023 46.3156L869.044 39.4377L865.556 32.2748L873.341 33.9728L879.074 28.4414Z",
    fill: "#FAFDFF",
    fillOpacity: 0.15
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_348_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M899.034 328.482L908.57 335.406L919.624 331.318L915.987 342.528L923.29 351.777L911.505 351.78L904.966 361.586L901.321 350.378L889.975 347.189L899.507 340.257L899.034 328.482Z",
    fill: "#FAFDFF",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.3936 326.548L38.196 335.014L40.6865 346.534L30.1006 341.354L19.9153 347.282L21.5716 335.614L12.7846 327.759L24.3933 325.729L29.1489 314.945L34.6693 325.359L46.3936 326.548Z",
    fill: "#FAFDFF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.824 -5.06444L723.361 1.85925L734.415 -2.22874L730.778 8.98111L738.081 18.2301L726.296 18.2335L719.756 28.039L716.111 16.832L704.766 13.6423L714.298 6.7105L713.824 -5.06444Z",
    fill: "#FAFDFF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.824 60.9356L423.361 67.8592L434.415 63.7713L430.778 74.9811L438.081 84.2301L426.296 84.2335L419.756 94.039L416.111 82.832L404.766 79.6423L414.298 72.7105L413.824 60.9356Z",
    fill: "#FAFDFF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_348_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.698 27.7631L177.62 37.3L189.397 36.837L182.467 46.369L186.546 57.4251L175.34 53.7782L166.085 61.076L166.09 49.291L156.291 42.7441L167.501 39.1056L170.698 27.7631Z",
    fill: "#FAFDFF",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_348_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M876.698 402.763L883.62 412.3L895.397 411.837L888.467 421.369L892.546 432.425L881.34 428.778L872.085 436.076L872.09 424.291L862.291 417.744L873.501 414.106L876.698 402.763Z",
    fill: "#FAFDFF",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_348_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M865.567 177.678L874.62 185.223L885.923 181.881L881.546 192.823L888.216 202.539L876.457 201.756L869.278 211.104L866.388 199.679L855.281 195.739L865.254 189.459L865.567 177.678Z",
    fill: "#FAFDFF",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_348_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M528.272 437.567L520.727 446.62L524.069 457.923L513.127 453.546L503.411 460.216L504.194 448.457L494.846 441.278L506.272 438.388L510.211 427.281L516.491 437.254L528.272 437.567Z",
    fill: "#FAFDFF",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14_348_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.487 431.886L98.2086 442.866L104.967 452.522L93.2012 451.847L86.1074 461.258L83.1146 449.859L71.9709 446.021L81.8867 439.652L82.094 427.869L91.2171 435.331L102.487 431.886Z",
    fill: "#FAFDFF",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15_348_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4868 36.8859L37.2086 47.8663L43.9671 57.522L32.2012 56.8473L25.1074 66.2579L22.1146 54.8593L10.9709 51.0212L20.8867 44.6523L21.094 32.8689L30.2171 40.3307L41.4868 36.8859Z",
    fill: "#FAFDFF",
    fillOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_348_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 927,
    height: 473,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_348_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.7043,
    height: 57.7043,
    fill: "white",
    transform: "translate(815.338 235.668) rotate(9.31317)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_348_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.7043,
    height: 57.7043,
    fill: "white",
    transform: "translate(638.282 411.338) rotate(99.3132)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_348_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86.6758,
    height: 86.6758,
    fill: "white",
    transform: "translate(-39 392.141) rotate(-30.6146)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_348_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157.133,
    height: 157.133,
    fill: "white",
    transform: "translate(677 386.022) rotate(-30.6146)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_348_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.7624,
    height: 64.7624,
    fill: "white",
    transform: "translate(58.4541 38.6482) rotate(20.6187)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_348_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6296,
    height: 33.6296,
    fill: "white",
    transform: "translate(883.172 239.668) rotate(20.17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_348_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6296,
    height: 33.6296,
    fill: "white",
    transform: "translate(466.282 455.172) rotate(110.17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_348_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.735,
    height: 22.735,
    fill: "white",
    transform: "translate(868.596 24) rotate(20.17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_348_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6296,
    height: 33.6296,
    fill: "white",
    transform: "translate(883.821 335.693) rotate(-28.1601)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_348_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6296,
    height: 33.6296,
    fill: "white",
    transform: "translate(154 29.9071) rotate(-10.1165)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_348_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6296,
    height: 33.6296,
    fill: "white",
    transform: "translate(860 404.907) rotate(-10.1165)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_348_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6296,
    height: 33.6296,
    fill: "white",
    transform: "translate(849.908 183.858) rotate(-24.3352)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_348_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6296,
    height: 33.6296,
    fill: "white",
    transform: "translate(522.092 421.908) rotate(65.6648)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14_348_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6296,
    height: 33.6296,
    fill: "white",
    transform: "translate(91.6531 419) rotate(47.145)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15_348_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6296,
    height: 33.6296,
    fill: "white",
    transform: "translate(30.6531 24) rotate(47.145)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedStarryBg);
export default __webpack_public_path__ + "static/media/red_starry_bg.d3014b479350853456b13dac21dc3600.svg";
export { ForwardRef as ReactComponent };